import styled from 'styled-components';

import { ModalWidth, StyledFlex } from '@dreryk/react-components';

const NFZ_MFA_TOTP_FIELD_WIDTH = '160px';
const MODAL_CONTENT_PADDING = '24px';

export const StyledNfzMfaTotpRow = styled(StyledFlex)`
   & > *:first-child {
      width: ${NFZ_MFA_TOTP_FIELD_WIDTH};
   }

   & > *:first-child [data-testid='error'] {
      width: max-content;
      max-width: calc(${ModalWidth.NORMAL} - 2 * ${MODAL_CONTENT_PADDING});
   }
`;
StyledNfzMfaTotpRow.displayName = 'StyledNfzMfaTotpRow';
